import template from './teamCalendarListCardDetail.html';
import controller from './teamCalendarListCardDetail.controller';
import './teamCalendarListCardDetail.scss';

let teamCalendarListCardDetailComponent = {
  restrict: 'E',
  bindings: {
    periodsInDate: '<'
  },
  template,
  controller
};

export default teamCalendarListCardDetailComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarListCard/teamCalendarListCardDetail/teamCalendarListCardDetail.component.js